import _extends from 'babel-runtime/helpers/extends';
import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';
import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';

var _templateObject = _taggedTemplateLiteral(['\n        ', ';\n      '], ['\n        ', ';\n      ']);

import React, { Component } from 'react';
import styled from 'styled-components';
import { Link, Text, linkStyles } from './styled';

var Content = function (_Component) {
  _inherits(Content, _Component);

  function Content() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Content);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Content.__proto__ || _Object$getPrototypeOf(Content)).call.apply(_ref, [this].concat(args))), _this), _this.getLinkComponent = function () {
      var _this$props = _this.props,
          linkComponent = _this$props.linkComponent,
          href = _this$props.href;


      if (!href) return null;

      if (linkComponent) return styled(linkComponent)(_templateObject, linkStyles);
      return Link;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Content, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          href = _props.href,
          isFocused = _props.isFocused,
          isRemovable = _props.isRemovable,
          markedForRemoval = _props.markedForRemoval,
          color = _props.color;

      var styledProps = { isFocused: isFocused, isRemovable: isRemovable, markedForRemoval: markedForRemoval, color: color };

      var LinkComponent = this.getLinkComponent();

      return href && LinkComponent ? React.createElement(
        LinkComponent,
        _extends({}, styledProps, { href: href, tabIndex: '-1' }),
        children
      ) : React.createElement(
        Text,
        styledProps,
        children
      );
    }
  }]);

  return Content;
}(Component);

export default Content;